import React from "react";
import { Drawer, Typography, IconButton, Divider } from "@mui/material";
import { AppTheme } from "../../theme/App.theme";
import { Icons } from "../../config/MuiIcons.config";

const MUIDrawer = ({ open, onClose, title, subtitle, children, ...rest }) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={(e, reason) => {
      if (["backdropClick", "escapeKeyDown"].includes(reason)) {
        return;
      }
      onClose();
    }}
    slotProps={{
      paper: {
        sx: {
          width: { xs: "100vw", sm: 550, md: 600 },
          height: "100vh",
          overflowY: "hidden",
          bgcolor: AppTheme.PRIMARY_WHITE,
        },
      },
    }}
    {...rest}
  >
    <div style={{ position: "relative" }} className="p-3 pb-0">
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 16,
          top: title && subtitle ? 16 : 8,
          color: AppTheme.PRIMARY_BLACK,
        }}
        aria-label="close"
      >
        <Icons.Close />
      </IconButton>
      <Typography
        className="plus-jakarta-sans-semi-bold-600"
        sx={{ mb: !subtitle ? 1.5 : 0.5, fontSize: "18px" }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          className="plus-jakarta-sans-bold-500"
          sx={{ color: "#999999", mb: 2, fontSize: "15px" }}
        >
          {subtitle}
        </Typography>
      )}
    </div>
    <Divider sx={{ color: "GrayText", border: "0.02rem solid GrayText" }} />
    <div style={{ flex: 1, overflowY: "auto" }} className="px-3 pt-2 pb-0">
      {children}
    </div>
  </Drawer>
);

export default MUIDrawer;
